/**
 * ==========================================================
 * QUICK VARIANT BADGES LOADER
 * ==========================================================
 */

(() => {

    let raf = null;

    function run() {
        if (typeof window.applyBadges !== 'function') return;
        window.applyBadges();
    }

    /* PRIMEIRA EXECUÇÃO */

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    window.addEventListener('load', run);

    /* OBSERVER */

    const observer = new MutationObserver(mutations => {

        let shouldRun = false;

        for (const mutation of mutations) {

            for (const node of mutation.addedNodes) {

                if (!(node instanceof HTMLElement))
                    continue;

                /* Ignora alterações feitas pelo próprio script */

                if (
                    node.classList?.contains('na-custom-badge') ||
                    node.classList?.contains('na-product-badges')
                ) {
                    continue;
                }

                /* Novo card ou galeria */

                if (

                    node.matches?.('product-card') ||
                    node.querySelector?.('product-card') ||

                    node.matches?.('.custom-product-card-media') ||
                    node.querySelector?.('.custom-product-card-media') ||

                    node.matches?.('.card-gallery') ||
                    node.querySelector?.('.card-gallery')

                ) {

                    shouldRun = true;
                    break;

                }

            }

            if (shouldRun)
                break;

        }

        if (!shouldRun || raf)
            return;

        raf = requestAnimationFrame(() => {

            raf = null;

            run();

        });

    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();